export class FormInputEvent {
	form_name: string;
	input_type: string;
	input_name: string;
	log_name?: string;

	constructor(form_name: string, input_type: string, input_name: string) {
		this.form_name = form_name;
		this.input_type = input_type;
		this.input_name = input_name;
		this.log_name = `${form_name}__${input_type}__${input_name}`;
	}
}
